<template>
  <div>

    <div
      class="modal-dialog modal-small"
      role="document">
      <div class="modal-content">
        <div
          class="modal-header"
          style="border-bottom: none;">
          <h5 class="modal-title">{{ $t('message.areyousuretodeletethis') }}</h5>
        </div>
        <div class="modal-footer">
          <button
            :disabled="$store.state.app.loading"
            type="button"
            class="btn btn-light"
            @click="cancel()">
            {{ $t('button.close') }}
          </button>
          <template>
            <button
              v-if="$store.state.app.loading"
              :disabled="true"
              type="button"
              class="btn btn-light">
              <i class="fas fa-spinner spin"/>
            </button>
            <button
              v-else
              type="button"
              class="btn btn-danger"
              @click="del()">
              {{ $t('button.delete') }}
            </button>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    app_id: {
      type: Number,
    },
    data: {
      type: Object,
    },
  },
  data () {
    return {

    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    async del () {
      let dataSet = {
        'ch_noti_id': this.data.ch_noti_id,
        'app_id': this.app_id,
      }

      await this.$store.dispatch('deleteChannelNoti', dataSet)

      this.$emit('done')
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/modal/channelnoti/Delete.vue